import { render, staticRenderFns } from "./VentasProducto.vue?vue&type=template&id=32108b61&"
import script from "./VentasProducto.vue?vue&type=script&lang=js&"
export * from "./VentasProducto.vue?vue&type=script&lang=js&"
import style0 from "./VentasProducto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports